<template>
  <div class="colums small-11 medium-10 small-centered">
    <button
      class="secondary button"
      :disabled="!$store.state.customCheckerboard.enableControls"
      @click="applySecondComponent"
    >
      {{ translations.continueSameCheckerboard }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'continueSameCheckerboard',
  computed: {
    translations(){
      return this.$store.state.translations.data;
    }
  },
  methods : {
    applySecondComponent() {
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$checkerboardDataLayer.logAnalyticsEvent({
          eventLabel: this.$checkerboardDataLayer.labels.continueSameCheckerboard
        });
      } else {
        dataLayer.push({
          'event': 'trackEvent',
          'eventCategory': 'customs',
          'eventAction': 'checkerboard - second component',
          'eventLabel': 'continue with same colors'
        });
      }

      const nextComponent = this.$store.getters['customCheckerboard/getNextUGCComponent'];
      this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", false);
      this.$store.commit('customCheckerboard/SET_COMPONENT_CONFIG', {
        component: nextComponent,
        canvasConfig: this.$store.state.customCheckerboard.canvasConfig
      });
      this.validateSameImage();
      this.$store.commit("customCheckerboard/NEXT_VIEW");
    },
    validateSameImage() {
      const { components, activeUGCComponent} = this.$store.state.customCheckerboard;
      if ( !!components[activeUGCComponent] && !!components[activeUGCComponent].ugc  &&  !!components[activeUGCComponent].ugc.original_image  ) {
        this.$store.commit('customCheckerboard/SET_SAME_UPLOAD_IMAGE', true);
      }
    }
  }
}
</script>
